<template>
    <div class="sub-visual">
        <v-container>
            <template v-if="this.$slots['titleContents']">
                <slot name="titleContents" />
            </template>
            <div v-else class="sub-visual__tit-wrap">
                <h2 class="sub-visual__tit" data-aos="fade-right">{{ title }}</h2>
            </div>
            <p v-if="text" class="font-size-16 font-size-md-20 font-size-lg-24 font-weight-regular" data-aos="fade-right" data-aos-delay="100">{{ text }}</p>
        </v-container>
        <div v-if="src" class="sub-visual__img" :style="'background-image:url(' + src + ');'"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, default: "" },
        text: { type: String, default: "" },
        src: { type: String, default: "" },
    },
    components: {},
    data: () => {
        return {};
    },
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init: function() {
            setTimeout(() => {
                AOS.init({
                    once: true,
                    offset: 240,
                    duration: 800,
                    throttleDelay: 100,
                    easing: "ease-in-out",
                    anchorPlacement: "top-center",
                });
            }, 100);
        },
    },
};
</script>

<style lang="scss" scoped>
.sub-visual {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 300px;
    color: #fff;
    padding-top: var(--header-body);
    &__tit-wrap{
        margin-bottom: 10px;
    }
    &__tit{
        font-size: 3.6rem;
        font-weight: 800;
        line-height: 1.1;
    }
    &__img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 400px;
        &__tit-wrap{
            margin-bottom: 20px;
        }
        &__tit{
            font-size: 5rem;
        }
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 500px;
        &__tit{
            font-size: 8rem;
            line-height: 1;
        }
    }
}
@media (min-width: 1200px) {
}
</style>
